export const environment = {
    production: true,
    gateway: 'https://mapache.clicklease.com/api/',
    userSecret: '302fd9fd741c725a444b10ffa6a1a43e',
    x3scaleProxySecretToken: '2F2989B64E87F7E7A8B5EEA53073C48EA0F890F4B9663C5A0970C26B9E22C06D9329F7428B8DB28F',
    xClkToken: '70B1150811FCA95C5E2D9A92CAE90B2FA91DE2768C47E12D4E2C9D45C948853C61978DA7A6CB6A25',
    xApplicationSource: 'rc',
    TRACKING_ID: 'UA-119826944-1',
    GA_DIMENSIONS: {
        DATA: 'dimension4',
        REFERRAL_PAGE: 'dimension14',
        GOOGLE_EXPERIENCE: 'dimension15',
        GOOGLE_VARIANT: 'dimension16'
    }
};


/*export const environment = {
production: true,
gateway: 'http://internal.click-lease.net/api/',
userSecret: '302fd9fd741c725a444b10ffa6a1a43e',
x3scaleProxySecretToken: '2F2989B64E87F7E7A8B5EEA53073C48EA0F890F4B9663C5A0970C26B9E22C06D9329F7428B8DB28F',
xClkToken: '70B1150811FCA95C5E2D9A92CAE90B2FA91DE2768C47E12D4E2C9D45C948853C61978DA7A6CB6A25'
};
*/